import React, { useState } from "react";
import { Box } from "@mui/material";
import ImagenNoDisponibleKawaii from "../ImagenNoDisponibleKawaii";

// Template43: Página de Kofi. Contenido desde page (backend). Colores configurables por headerBackgroundColor.
const Template43 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const headerText = page?.texts?.[0]?.content;
	const titulo = page?.texts?.[1]?.content;
	const texto = page?.texts?.[2]?.content;
	const buttonLabel = page?.texts?.[3]?.content;
	const graciasText = page?.texts?.[4]?.content;
	const kofiLink = page?.texts?.[5]?.content;
	const cafeImage = getImageSrc("kofi-illustration");
	const [cafeError, setCafeError] = useState(false);

	const pageOrder = page?.order !== undefined ? page.order : (page?.data?.order !== undefined ? page.data.order : -1);
	const isTokioGuide = headerBackgroundColor === "#24221a";
	const actualHeaderColor = isTokioGuide && pageOrder > 0 ? "#e24217" : (headerBackgroundColor || "#6D9E71");
	// Para Kioto: caja verde clara y acentos verdes; para Tokio: tonos naranja
	const boxBg = isTokioGuide ? "rgb(255, 227, 204)" : "#E9F2EB";
	const boxBorder = isTokioGuide ? "rgb(242, 139, 53)" : actualHeaderColor;
	const accentColor = isTokioGuide ? "rgb(226, 66, 23)" : actualHeaderColor;

	const box = {
		backgroundColor: boxBg,
		border: `3px solid ${boxBorder}`,
		borderRadius: "16px",
		padding: "16px",
	};

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: "8px",
		color: accentColor,
	};

	const contentColor = textColor || "#444";

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
			    height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
				"& p": {
					marginTop: "0px !important",
					marginBottom: "10px !important",
				},
				"& .marginTop": {
					marginTop: "20px !important",
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
						fontSize: "14px",
						fontWeight: 800,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 1053,
					}}
				>
					{headerText}
				</Box>
			)}

			<Box data-block-id="text-1" sx={{ padding: "20px" }}>
				<Box sx={{ ...box, padding: "20px" }}>
					<Box>
						{titulo && (
							<Box
								component="h2"
								sx={{
									...h3,
									marginTop: 0,
									paddingTop: 0,
									textAlign: "center",
								}}
							>
								{titulo}
							</Box>
						)}
						{texto && (
							<Box component="p" sx={{ ...p, margin: "0 !important", marginBottom: "0px !important" }}>
								{texto}
							</Box>
						)}
						{cafeImage && !cafeError ? (
							<Box
								component="img"
								src={cafeImage}
								alt="cafe"
								title="cafe"
								onError={() => setCafeError(true)}
								sx={{
									display: "block",
									margin: "auto",
									marginTop: "40px",
									marginBottom: "20px",
									maxWidth: "80%",
									width: 130,
								}}
							/>
						) : (
							<ImagenNoDisponibleKawaii width={130} height={130} fontFamily={fontFamily || "'Poppins', sans-serif"} compact />
						)}
						{kofiLink && (
							<Box
								component="a"
								href={kofiLink}
								sx={{
									backgroundColor: accentColor,
									color: "#ffffff",
									border: "none",
									borderRadius: "8px",
									padding: "12px 12px",
									fontWeight: 800,
									cursor: "pointer",
									fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
									marginTop: "20px",
									display: "block",
									textAlign: "center",
									textDecoration: "none",
								}}
								target="_blank"
								rel="noreferrer"
							>
								{buttonLabel || "Invitar a un Kofi ☕"}
							</Box>
						)}
						{graciasText && (
							<Box component="p" className="marginTop" sx={{ ...p, textAlign: "center", marginTop: "20px", margin: "20px 0 0 0 !important", marginBottom: "0px !important" }}>
								{graciasText}
							</Box>
						)}
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

Template43.thumbnail = "/images/template-1.png";

export default Template43;

